// extracted by mini-css-extract-plugin
export default {"Footer":"footer_Footer__vR5-x","copyRightText":"footer_copyRightText__KJzpG"};